/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Kreditportal Backend API
 * Das Kreditportal ermöglicht Versicherungsnehmern die Kautionsverträge einzusehen, anzupassen und Bürgschaften zu beantragen. Diese API ist eine Middleware fürs Frontend zu den Backend-Systemen.
 * OpenAPI spec version: 4.0.6-FINAL
 */
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpResponse as AngularHttpResponse } from '@angular/common/http';

import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import type {
    DeleteFirmenverbundFreigabeEntziehenParams,
    Firmenverbund,
    PostFirmenverbundEinspringenParams,
    PutFirmenverbundFreigabeGewaehrenParams
} from '../kreditportalBackendAPI.schemas';


interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        (item) =>
          item != null &&
          (typeof item === 'string' ||
            typeof item === 'number' ||
            typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (
      preserveRequiredNullables &&
      value === null &&
      requiredNullableKeys.has(key)
    ) {
      filteredParams[key] = null;
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class FirmenverbundApiService {
  private readonly http = inject(HttpClient);
/**
 * Dieser Service ermöglicht das Gewähren der Freigabe eines Nutzers im Firmenverbund, in dem sich der Nutzer befindet.
 * @summary Einem anderen Mitglied im Firmenverbund Freigabe gewähren
 */
 putFirmenverbundFreigabeGewaehren<TData = void>(params: PutFirmenverbundFreigabeGewaehrenParams, options?: HttpClientBodyOptions): Observable<TData>;
 putFirmenverbundFreigabeGewaehren<TData = void>(params: PutFirmenverbundFreigabeGewaehrenParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 putFirmenverbundFreigabeGewaehren<TData = void>(params: PutFirmenverbundFreigabeGewaehrenParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  putFirmenverbundFreigabeGewaehren<TData = void>(
    params: PutFirmenverbundFreigabeGewaehrenParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/api/firmenverbund/freigabe`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/api/firmenverbund/freigabe`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.put<TData>(
      `/api/firmenverbund/freigabe`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Dieser Service ermöglicht das Entziehen der Freigabe eines Nutzers im Firmenverbund, in dem sich der Nutzer befindet.
 * @summary Einem anderen Mitglied im Firmenverbund Freigabe entziehen
 */
 deleteFirmenverbundFreigabeEntziehen<TData = void>(params: DeleteFirmenverbundFreigabeEntziehenParams, options?: HttpClientBodyOptions): Observable<TData>;
 deleteFirmenverbundFreigabeEntziehen<TData = void>(params: DeleteFirmenverbundFreigabeEntziehenParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteFirmenverbundFreigabeEntziehen<TData = void>(params: DeleteFirmenverbundFreigabeEntziehenParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteFirmenverbundFreigabeEntziehen<TData = void>(
    params: DeleteFirmenverbundFreigabeEntziehenParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/firmenverbund/freigabe`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/firmenverbund/freigabe`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.delete<TData>(
      `/api/firmenverbund/freigabe`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Setzt den aktiven Kontext zurück auf den ursprünglich eingeloggten Nutzer.
 * @summary Rücksprung aus einem Firmenverbund-Partner in den eigenen Account
 */
 postFirmenverbundRuecksprung<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 postFirmenverbundRuecksprung<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postFirmenverbundRuecksprung<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postFirmenverbundRuecksprung<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/firmenverbund/ruecksprung`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/firmenverbund/ruecksprung`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/firmenverbund/ruecksprung`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Prüft die erhaltene Freigabe und setzt den ausgewählten Partner als aktiven Kontext.
 * @summary In den Account eines Firmenverbund-Partners einspringen
 */
 postFirmenverbundEinspringen<TData = void>(params: PostFirmenverbundEinspringenParams, options?: HttpClientBodyOptions): Observable<TData>;
 postFirmenverbundEinspringen<TData = void>(params: PostFirmenverbundEinspringenParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postFirmenverbundEinspringen<TData = void>(params: PostFirmenverbundEinspringenParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postFirmenverbundEinspringen<TData = void>(
    params: PostFirmenverbundEinspringenParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/firmenverbund/einspringen`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/firmenverbund/einspringen`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.post<TData>(
      `/api/firmenverbund/einspringen`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Dieser Service ermöglicht das Ermitteln des Firmenverbunds, in dem sich der Nutzer befindet.
 * @summary Ermitteln des Firmenverbunds zum Login
 */
 getFirmenverbund<TData = Firmenverbund>( options?: HttpClientBodyOptions): Observable<TData>;
 getFirmenverbund<TData = Firmenverbund>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getFirmenverbund<TData = Firmenverbund>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getFirmenverbund<TData = Firmenverbund>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/firmenverbund/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/firmenverbund/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/firmenverbund/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

